import { __extends } from 'tslib';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var EEndpointTypes = {
    CPU: 1,
    RAM: 2,
};
EEndpointTypes[EEndpointTypes.CPU] = 'CPU';
EEndpointTypes[EEndpointTypes.RAM] = 'RAM';
/** @type {?} */
var topNComponentSelector = 'lib-ng-top-n';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Transforms Data Transfer Object (contract) which came from the API to a Model.
 * Model is a subset of the DTO or can even contain metadata.
 * Model is an object that can be used straight from our components/services
 * @abstract
 * @template DTO, MODEL
 */
var  /**
 * Transforms Data Transfer Object (contract) which came from the API to a Model.
 * Model is a subset of the DTO or can even contain metadata.
 * Model is an object that can be used straight from our components/services
 * @abstract
 * @template DTO, MODEL
 */
ApiMapping = /** @class */ (function () {
    function ApiMapping() {
    }
    return ApiMapping;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TopNMapper = /** @class */ (function (_super) {
    __extends(TopNMapper, _super);
    function TopNMapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} dto
     * @return {?}
     */
    TopNMapper.prototype.dtoToModel = /**
     * @param {?} dto
     * @return {?}
     */
    function (dto) {
        /** @type {?} */
        var res = [];
        dto.rows.forEach(function (r) {
            res.push({
                title: r.title,
                value: r.value
            });
        });
        return res;
    };
    /**
     * @param {?} model
     * @return {?}
     */
    TopNMapper.prototype.modelToDto = /**
     * @param {?} model
     * @return {?}
     */
    function (model) {
        throw new Error("Method not implemented.");
    };
    return TopNMapper;
}(ApiMapping));

var _a, _b;
/** @type {?} */
var baseUrl = '';
/** @type {?} */
var authToken = '';
/** @enum {string} */
var EApiRequests = {
    CPU: 'https://nsx-sm-api.kissmybutton.gr/cpu/total',
    RAM: 'https://nsx-sm-api.kissmybutton.gr/ram/total',
};
/** @type {?} */
var defaultApiConfiguration = (_a = {},
    _a[topNComponentSelector] = (_b = {},
        _b[EEndpointTypes.CPU] = {
            url: EApiRequests.CPU,
            mapper: TopNMapper
        },
        _b[EEndpointTypes.RAM] = {
            url: EApiRequests.RAM,
            mapper: TopNMapper
        },
        _b),
    _a);

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { baseUrl, authToken, EApiRequests, defaultApiConfiguration, ApiMapping, TopNMapper, EEndpointTypes, topNComponentSelector };

//# sourceMappingURL=kissmybutton-nsx-ui-common-lib.js.map